import { restoreFromLocalStorage } from "@/lib/restoreFromLocalStorage";
import reportService from "@/services/mrfiktiv/services/reportService";
import {
  MrfiktivReportControllerFindAllPaginatedParamsGen,
  MrfiktivReportViewmodelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, getModule, Module } from "vuex-module-decorators";
import { BasePagination } from "./base-pagination.store";

@Module({
  dynamic: true,
  namespaced: true,
  name: "reportPagination",
  store
})
export class ReportPaginationStore extends BasePagination<
  MrfiktivReportViewmodelGen,
  MrfiktivReportControllerFindAllPaginatedParamsGen
> {
  protected _pageOrder = restoreFromLocalStorage("_itemsPerPage", "reportPagination", "ascending") || "ascending";
  protected _itemsPerPage = restoreFromLocalStorage("_itemsPerPage", "reportPagination", 100) || 100;
  protected _totalPages = restoreFromLocalStorage("_totalPages", "reportPagination", 0) || 0;
  protected _paginationList: MrfiktivReportViewmodelGen[] =
    restoreFromLocalStorage("_paginationList", "reportPagination", []) || [];
  protected _currentPage = restoreFromLocalStorage("_currentPage", "reportPagination", 1) || 1;
  protected _totalItems = restoreFromLocalStorage("_totalItems", "reportPagination", 0) || 0;
  protected _isLoadAll = restoreFromLocalStorage("_isLoadAll", "reportPagination", false) || false;

  @Action
  protected async loadDocuments(query: any): Promise<any> {
    return reportService.getReportPaginated({
      currentPage: this.currentPage,
      itemsPerPage: this.itemsPerPage,
      ...query
    });
  }
}

export const ReportPaginationModule = getModule(ReportPaginationStore);
